/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Relieved = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Relieved"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
        className="Fill-Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M16.411 14.744a.833.833 0 0 1 1.179 1.178 7.905 7.905 0 0 1-11.179 0 .833.833 0 1 1 1.179-1.178 6.24 6.24 0 0 0 8.821 0m-7.744-6.91a1.667 1.667 0 1 1 0 3.334 1.667 1.667 0 0 1 0-3.335m6.667 0a1.667 1.667 0 1 1-.002 3.333 1.667 1.667 0 0 1 .002-3.334"
        className="Fill-Secondary"
      />
    </g>
  </svg>
);

export const RelievedIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'relieved-icon'}
      icon={Relieved}
      {...props}
      size={size}
    />
  );
};
